// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2_HIv","title":"ClientInsurance_title__2nHXr","itemText":"ClientInsurance_itemText__sxMqV"};